export default __webpack_public_path__ + "static/media/wifi.b43b771d.svg";